import { oneOf, string, } from 'prop-types';
import Thumbnail from './thumbnail';
import MissingPreview from './missingPreview';
import { PROJECT_TYPES } from '../../config';

function MediaThumbnail({ id, type }) {

  if (['single', 'panorama', 'video'].includes(type)) {
    return (
      <Thumbnail id={id} />
    )
  }
  return <MissingPreview type={type} />
}

MediaThumbnail.propTypes = {
  id: string.isRequired,
  type: oneOf([...PROJECT_TYPES, 'forestRGB', 'forestMulti']).isRequired,
};

export default MediaThumbnail;